export default "__VITE_ASSET__CTV7C2Qr__"